import React from "react"
import classNames from "classnames"

import { ISocialLink } from "../../interfaces"
import SVG from "../../svg"

import "../../../styles/social-icons.base.scss"
import * as styles from "./styles.module.scss"

const SocialMediaLinks = ({ links }: { links: ISocialLink[] }) => (
  <div
    className={classNames(
      styles.social_media_links,
      "container-lg p-responsive py-2 social_media_links"
    )}
  >
    {links != null &&
      links?.map((link) => {
        let vendorName = link.vendor || "picture"

        return (
          <a href={link.url} target="_blank" rel="noreferrer noopener" key={link.id}>
            {vendorName === "Reddit" ? (
              <i className="icon-svg">
                <SVG name="reddit" />
              </i>
            ) : vendorName === "Tiktok" ? (
              <i className="icon-svg">
                <SVG name="tiktok" />
              </i>
            ) : vendorName === "Flickr" ? (
              <i className="icon-svg">
                <SVG name="flickr" />
              </i>
            ) : (
              <i className={`icon-${vendorName.toLowerCase()}`}></i>
            )}
          </a>
        )
      })}
  </div>
)

export default SocialMediaLinks
